import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { GalleryRelatedOfficeComponent } from './gallery-related-office.component';

import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        SharedPipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        GalleryRelatedOfficeComponent
    ],
    exports: [
        GalleryRelatedOfficeComponent
    ]
})
export class GalleryRelatedOfficeModule { }
